import { useCallback } from "react";
import { FLASHY_EVENTS } from "../flashy/FLASHY_EVENTS";
import { FlashyCreateOrUpdate } from "../models/flashy-create-or-update";

declare global {
    interface Window {
        flashy?: {
            contacts: {
                createOrUpdate: (
                    data: Record<string, unknown>,
                ) => void;
            };
            setCustomer: (data: Record<string, unknown>) => void;
        };
    }
}

export function useFlashy() {
    const sendEvent = useCallback(
        (
            event: string,
            data: FlashyCreateOrUpdate,
        ) => {
            switch (event) {
                // register event - create or update contact
                case FLASHY_EVENTS.CREATE_OR_UPDATE:
                    try {
                        window.flashy!.contacts.createOrUpdate(data);
                        console.log('flashy event createOrUpdate:', data);
                    } catch (error) {
                        console.error(
                            "[FLASHY_EVENTS.CREATE_OR_UPDATE] Failed to create or update contact:",
                            error,
                        );
                    }
                    break;

                // login event - set customer
                case FLASHY_EVENTS.SET_CUSTOMER:
                    try {
                        window.flashy!.setCustomer(data);
                        console.log('flashy event setCustomer:', data);
                    } catch (error) {
                        console.error(
                            "[FLASHY_EVENTS.SET_CUSTOMER] Failed to set customer:",
                            error,
                        );
                    }
                    break;

                default:
                    break;
            }
        },
        [],
    );

    return { sendEvent };
}